<template>
  <div class="channel-bg fill-height">
    <v-container class="fill-height justify-center" tag="section">
      <v-row justify="center">
        <v-col sm="8" md="6" lg="5" xl="4">
          <v-card class="elevation-4">
            <v-row>
              <v-col lg="12">
                <div class="pa-7 pa-sm-12">
                  <!-- <img src="@/assets/logo.png" /> -->
                  <h2
                    class="font-weight-bold mt-4 blue-grey--text text--darken-2"
                  >
                    Channel Manager
                  </h2>
                  <h6 class="subtitle-1">
                    Enter the Channel ID.
                  </h6>
                  <v-form ref="form">
                    <v-text-field
                      v-model="channelId"
                      :rules="ruleChannelId"
                      label="Channel ID"
                      color="channel"
                      class="mt-4"
                      required
                      outlined
                      @keyup.enter="enterHandler"
                      @keypress.enter.prevent
                    ></v-text-field>
                  </v-form>
                  <v-btn
                    :disabled="!valid"
                    color="light-blue"
                    block
                    class="mr-4 white--text"
                    @click="enterHandler"
                    >Enter</v-btn
                  >
                </div>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
// import jwtDecode from "jwt-decode";

export default {
  name: "Channel",
  data: () => ({
    valid: true,
    channelId: "",
    ruleChannelId: [
      v => !!v || "Required.",
      v => (v && v.length >= 2) || "Min 2 characters",
      v => (v && v.length <= 16) || "Max 16 characters",
      v => {
        const pattern = /^[^0-9A-Z][a-z0-9]+$/g;
        return (
          pattern.test(v) ||
          "Invalid Value. You should use lower alphabets and digit Numbers."
        );
      }
    ]
  }),
  computed: {},
  methods: {
    async enterHandler() {
      if (!this.$refs.form.validate()) return;
      console.log(this.channelId);

      this.$store.commit("SET_CHANNEL_ID", this.channelId);
      if (this.channelId && this.$store.state.user) {
        await this.$store.dispatch("getChannelProfile", this.channelId);
      }
      this.$router
        .push({ name: "Dashboards", params: { id: this.channelId } })
        .catch(() => {});
    }
  }
};
</script>
<style>
.channel-bg {
  background-color: #dad4d2;
  background-image: url("../assets/images/channel_bg.jpg");
  background-position: center;
  background-size: cover;
}
</style>
